import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Flex, Hide, Link } from 'pcln-design-system'
import { themeGet } from '@styled-system/theme-get'
import {
  fireEventForViewMoreDeals,
  renderXSellProducts
} from '@/components/CrossSell/inventoryHelper'
import useBootstrapData from '@/hooks/useBootstrapData'
import analytics from '@/shared-utils/analytics'
import buildGA4ObjectForPostBookingXSell from '@/shared-utils/ga4/post-booking-xsell'
import { Listing, ProductType } from './types'
import { HeadingNonXL, HeadingXL } from './InventoryHeading'

const ViewMoreDeals = styled(Link)`
  font-size: 12px;
  font-weight: bold;
`

const ScrollContainer = styled(Flex)`
  overflow: auto hidden;
  & > :last-child {
    margin-right: ${themeGet('space.1')}px;
  }
`

export default function Inventory({
  xSellMessaging,
  xSellProduct,
  xSellUrl,
  listings,
  offerToken,
  offerId,
  parentProductId,
  xSellTargetId,
  destination
}: {
  xSellMessaging: string
  xSellProduct: 'rental car' | 'flight' | 'hotel'
  xSellUrl: string
  listings: Listing[]
  offerToken: string
  offerId: string
  parentProductId: ProductType
  xSellTargetId: ProductType
  destination: string
}) {
  const { isMobile = false } = useBootstrapData()

  useEffect(() => {
    analytics.fireGA4Event(
      buildGA4ObjectForPostBookingXSell({
        event: 'view_promotion_bundle',
        product: parentProductId,
        xSellProduct: xSellTargetId,
        offerId,
        destination,
        listings
      })
    )
  }, [parentProductId, xSellTargetId, offerId, destination, listings])

  const viewMoreDeals = ({ target }: { target?: string } = {}) => (
    <ViewMoreDeals
      onClick={() =>
        fireEventForViewMoreDeals({
          event: 'select_promotion_bundle',
          product: parentProductId,
          xSellProduct: xSellTargetId,
          offerId,
          destination
        })
      }
      href={xSellUrl}
      target={target}
      color="primary"
      variation="fill"
      py={2}
      px={3}
    >
      View more {xSellProduct} deals
    </ViewMoreDeals>
  )
  const renderedProducts = renderXSellProducts({
    listings,
    offerToken,
    numProducts: isMobile ? 2 : 3,
    offerId,
    parentProductId,
    destination
  })

  return (
    <>
      <Hide width={8 / 11} mt={40} ml={24} xs sm md lg>
        <HeadingXL xSellMessaging={xSellMessaging}>
          {viewMoreDeals({ target: '_blank' })}
        </HeadingXL>
        <ScrollContainer data-testid="inventory-list" mt={12}>
          {renderedProducts}
        </ScrollContainer>
      </Hide>
      <Hide
        width={[1, null, 2 / 3]}
        mt={[24, null, 3, 40]}
        ml={[0, null, null, 24]}
        mb={[0, null, null, 24]}
        xl
        xxl
      >
        <HeadingNonXL xSellMessaging={xSellMessaging}>
          {viewMoreDeals({ target: '_blank' })}
        </HeadingNonXL>
        <ScrollContainer
          mx={[-3, null, null, 0]}
          px={[3, null, null, 0]}
          mt={24}
        >
          {renderedProducts}
        </ScrollContainer>
      </Hide>
    </>
  )
}
